import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output, input } from '@angular/core';

@Component({
    selector: 'app-route-page',
    imports: [CommonModule],
    templateUrl: './route-page.component.html',
    styleUrls: ['./route-page.component.scss'],
    standalone: true
})
export class RoutePageComponent {
    readonly goBack = input<boolean>(false);
    readonly intro = input('');
    readonly introSub = input('');
    readonly introAlignment = input<string>('center');
    readonly progressBar = input<boolean>(false);
    readonly width = input<any>();
    readonly introTextMaxWidth = input('790px');
    readonly introSubMaxWidth = input('790px');

    @Output() navigatePage = new EventEmitter<any>();
    isMobileWidth: boolean;

    pageNavigation(data: any) {
        this.navigatePage.emit(data);
    }

    @HostListener('window:resize')
    getWidthOfScreenSize() {
        const screenWidth = window.innerWidth;
        if (screenWidth <= 576) {
            this.isMobileWidth = true;
        } else {
            this.isMobileWidth = false;
        }
    }
}
